<div class="spinner-overlay" *ngIf="isLoading">
  <nz-spin nzSpinning="true" nzSize="large">
    <div class="spinner-content">Creating model...</div>
  </nz-spin>
</div>

<div class="model-wrapper">
  <nz-card>
    <div class="card-body">
      <h3 nz-typography class="nfl-form-label">Create New Lookalike Model</h3>
      <form nz-form [nzLayout]="'vertical'" [formGroup]="modelForm!" class="form-grid">
        <div nz-row [nzGutter]="[16, 24]">
          <div nz-col class="gutter-row" [nzSpan]="24">
            <nz-form-item>
              <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true"> Model Name</nz-form-label>
              <nz-form-control [nzErrorTip]="modelNameErrorTemplate">
                <input nz-input formControlName="modelName" id="modelName" placeholder="Enter Model Name" />
              </nz-form-control>
            </nz-form-item>
            <ng-template #modelNameErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Model name is required</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Model name cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
              <div *ngIf="control?.errors?.['pattern']">
                Model name should not contain any special characters and should have at least one alphabet.
              </div>
            </ng-template>

            <nz-form-item>
              <nz-form-label class="nfl-form-label" [nzNoColon]="true" [nzRequired]="true">
                Seed Audience</nz-form-label
              >
              <nz-form-control [nzErrorTip]="seedAudienceErrorTemplate" [nzSuccessTip]="seedSizeTemplate">
                <nz-select
                  nzShowSearch
                  nzAllowClear
                  formControlName="seedAudience"
                  nzPlaceHolder="Select Seed Audience"
                  [nzLoading]="loadingQueries"
                  [nzNotFoundContent]="loadingQueries ? 'Loading...' : 'No queries available'"
                >
                  <nz-option
                    *ngFor="let query of availableQueries"
                    [nzLabel]="getDisplayName(query)"
                    [nzValue]="query.queryId"
                    [nzDisabled]="getSeedAudienceCount(query) < 1000"
                    [nzTitle]="
                      getSeedAudienceCount(query) < 1000 ? getDisabledTooltipMessage(query) : getDisplayName(query)
                    "
                  >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>

            <ng-template #seedAudienceErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Seed Audience selection is required</div>
            </ng-template>

            <ng-template #seedSizeTemplate>
              <div class="nfl-form-label">Seed Audience Size: {{ seedAudienceCount }}</div>
            </ng-template>
          </div>
        </div>

        <nz-divider></nz-divider>
        <div class="button-container">
          <button
            nz-button
            nzType="primary"
            [nzLoading]="isLoading"
            [disabled]="modelForm.invalid || loadingQueries"
            (click)="createModel()"
          >
            <span>Train Model</span>
          </button>
        </div>
      </form>
    </div>
  </nz-card>
</div>
